module.exports = __webpack_public_path__ + "static/img/icon_horizontal.1cf0401e.svg";